(() => {
  const initialized = new WeakSet();
  const fittedHeaders = new WeakSet();
  const fitHeader = (header) => {
    if (!header || fittedHeaders.has(header)) return;
    fittedHeaders.add(header);
    let frame;
    const measure = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const styles = getComputedStyle(header);
        const innerWidth = header.clientWidth - parseFloat(styles.paddingLeft) - parseFloat(styles.paddingRight);
        const logoWidth = header.querySelector('.header__heading')?.getBoundingClientRect().width || 84;
        const gap = parseFloat(styles.columnGap) || 0;
        const available = (innerWidth - Math.max(84, logoWidth) - gap * 2) / 2;
        const actionsWidth = header.querySelector('.header__icons')?.scrollWidth || 0;
        header.classList.toggle('sc-header--localized-compact', window.innerWidth >= 990 && actionsWidth > available - 12);
        const headerHeight = (header.closest('.section-header') || header).offsetHeight;
        document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
      });
    };
    const observer = new ResizeObserver(measure);
    observer.observe(header);
    header.querySelectorAll('.header__icons, .header__inline-menu').forEach((element) => observer.observe(element));
    window.addEventListener('resize', measure, { passive: true });
    document.fonts.ready.then(measure);
    measure();
  };
  const close = (details, restoreFocus = false) => {
    if (!details.open) return;
    details.open = false;
    if (restoreFocus) details.querySelector('summary')?.focus();
  };
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-sc-localization]').forEach((details) => {
      if (initialized.has(details)) return;
      initialized.add(details);
      fitHeader(details.closest('.header'));
      const form = details.querySelector('form');
      const submitLocalization = (event) => {
        event.preventDefault();
        const country = form.querySelector('[name="country_code"]');
        const language = form.querySelector('[name="locale_code"]');
        const countryChanged = country.value !== details.dataset.currentCountry;
        const languageChanged = language.value !== details.dataset.currentLanguage;
        country.disabled = !countryChanged;
        language.disabled = !languageChanged;
        if (countryChanged && languageChanged) {
          const returnTo = form.querySelector('[name="return_to"]');
          const destination = new URL(returnTo.value, window.location.origin);
          const currentRoot = (window.Shopify?.routes?.root || '/').replace(/\/$/, '');
          const path = currentRoot && destination.pathname.startsWith(currentRoot) ? destination.pathname.slice(currentRoot.length) : destination.pathname;
          const primaryLanguage = 'en';
          destination.pathname = (language.value === primaryLanguage ? '' : `/${language.value}`) + (path.startsWith('/') ? path : `/${path}`);
          returnTo.value = destination.pathname + destination.search + destination.hash;
        }
        form.submit();
      };
      form.addEventListener('submit', submitLocalization);
      form.querySelector('.sc-localization__apply').addEventListener('click', submitLocalization);
      const summary = details.querySelector('summary');
      summary.setAttribute('aria-expanded', String(details.open));
      details.addEventListener('toggle', () => {
        summary.setAttribute('aria-expanded', String(details.open));
      });
      details.querySelector('[data-sc-localization-close]')?.addEventListener('click', () => close(details, true));
      details.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !details.open) return;
        event.preventDefault();
        event.stopPropagation();
        close(details, true);
      });
    });
  };
  document.addEventListener('click', (event) => {
    document.querySelectorAll('[data-sc-localization][open]').forEach((details) => {
      if (!details.contains(event.target)) close(details);
    });
  });
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
})();
